export const mapRoutes = [{
		"routeid": "route1",
		routename: '推荐线路1',
		markerid: 9901,
		iconPath: 'https://farm.evcc.top/Uploads/yuanboyuan/maps/car.png',
		width: 30,
		height: 30,
		duration: 12000,
		pois: [{
				"name": "东大门",
				"longitude": 112.18105933779475,
				"latitude": 31.012043011088906
			},
			{
				"name": "鄂州园",
				"longitude": 112.17881465821602,
				"latitude": 31.013901885071804
			},
			{
				"name": "十堰园",
				"longitude": 112.17867265821602,
				"latitude": 31.014620885071803
			},
			{
				"name": "县市区展园",
				"longitude": 112.18049382319043,
				"latitude": 31.015819214297643
			},
			{
				"name": "孝感园",
				"longitude": 112.17806565821603,
				"latitude": 31.016300885071803
			},
			{
				"name": "东宝园",
				"longitude": 112.17672565821603,
				"latitude": 31.019657885071803
			},
			{
				"name": "仙桃园",
				"longitude": 112.17308565821603,
				"latitude": 31.017069885071803
			},
			{
				"name": "天门园",
				"longitude": 112.17386965821603,
				"latitude": 31.017813885071803
			},
			{
				"name": "襄阳园",
				"longitude": 112.17330165821603,
				"latitude": 31.013810885071804
			},
			{
				"name": "黄冈园",
				"longitude": 112.17274965821603,
				"latitude": 31.014013885071803
			},
			{
				"name": "武汉园",
				"longitude": 112.17377065821603,
				"latitude": 31.011619885071804
			},
			{
				"name": "随州园",
				"longitude": 112.17337465821603,
				"latitude": 31.009880885071803
			},
			{
				"name": "神农架园",
				"longitude": 112.17449965821603,
				"latitude": 31.010694885071804
			},
			{
				"name": "荆门园",
				"longitude": 112.17520365821603,
				"latitude": 31.011584885071803
			},
			{
				"name": "南区",
				"longitude": 112.17925632895458,
				"latitude": 31.01001152545432
			},
			{
				"name": "东大门",
				"longitude": 112.18106433736796,
				"latitude": 31.01188746801176
			}
		]

	},
	{
		"routeid": "route2",
		routename: '推荐线路2',
		markerid: 9902,
		iconPath: 'https://farm.evcc.top/Uploads/yuanboyuan/maps/man.png',
		width: 30,
		height: 30,
		duration: 30000,
		pois: [{
				"name": "西门停车场",
				"longitude": 112.17266219073917,
				"latitude": 31.012606358352972
			}, {
				"name": "武汉园",
				"longitude": 112.17377065821603,
				"latitude": 31.011619885071804
			},
			{
				"name": "荆州园",
				"longitude": 112.17472889845317,
				"latitude": 31.012972954898466
			},
			{
				"name": "宜昌园",
				"longitude": 112.17430565821602,
				"latitude": 31.013497885071804
			},
			{
				"name": "自然博物馆",
				"longitude": 112.17592065821603,
				"latitude": 31.015227885071804
			},
			{
				"name": "黄石",
				"longitude": 112.17881265821602,
				"latitude": 31.014171885071803
			},
			{
				"name": "十堰",
				"longitude": 112.17867265821602,
				"latitude": 31.014620885071803
			},
			{
				"name": "东大门",
				"longitude": 112.18106433736796,
				"latitude": 31.01188746801176
			},
			{
				"name": "荆门园",
				"longitude": 112.17520365821603,
				"latitude": 31.011584885071803
			},
			{
				"name": "神农架",
				"longitude": 112.17449965821603,
				"latitude": 31.010694885071804
			},
			{
				"name": "随州园",
				"longitude": 112.17337465821603,
				"latitude": 31.009880885071803
			},
			{
				"name": "西门停车场",
				"longitude": 112.1727039841495,
				"latitude": 31.012396214804802
			}

		]
	},
	{
		"routeid": "route3",
		routename: '推荐线路3',
		markerid: 9903,
		iconPath: 'https://farm.evcc.top/Uploads/yuanboyuan/maps/car.png',
		width: 30,
		height: 30,
		duration: 30000,
		pois: [{
				"name": "东大门",
				"longitude": 112.18106433736796,
				"latitude": 31.01188746801176
			},
			{
				"name": "鄂州园",
				"longitude": 112.17881465821602,
				"latitude": 31.013901885071804
			},
			{
				"name": "十堰园",
				"longitude": 112.17867265821602,
				"latitude": 31.014620885071803
			},
			{
				"name": "恩施园",
				"longitude": 112.17809465821603,
				"latitude": 31.014727885071804
			},
			{
				"name": "自然博物馆",
				"longitude": 112.17592065821603,
				"latitude": 31.015227885071804
			},
			{
				"name": "宜昌园",
				"longitude": 112.17430565821602,
				"latitude": 31.013497885071804,
			},
			{
				"name": "荆州园",
				"longitude": 112.17462965821603,
				"latitude": 31.012912885071803
			},
			{
				"name": "武汉园",
				"longitude": 112.17377065821603,
				"latitude": 31.011619885071804
			},
			{
				"name": "随州园",
				"longitude": 112.17337465821603,
				"latitude": 31.009880885071803
			},
			{
				"name": "神农架园",
				"longitude": 112.17449965821603,
				"latitude": 31.010694885071804
			},
			{
				"name": "荆门园",
				"longitude": 112.17520365821603,
				"latitude": 31.011584885071803
			},
			{
				"name": "东大门",
				"longitude": 112.18105933779475,
				"latitude": 31.012043011088906
			}
		]
	}
]